import { getErrorMessage } from '@/components/hooks/useGetErrorMessage';
import { BusinessUnitEntity } from '@/domains/business-unit/entities';
import { BusinessUnitPayloadForm } from '@/domains/business-unit/ports/payloads';
import { UpdateBusinessUnitUsecase } from '@/domains/business-unit/usecases';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, notification } from 'antd';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';

const { confirm } = Modal;

export interface FormatDataEditOptions {
  data: BusinessUnitPayloadForm;
  detail: BusinessUnitEntity;
  handleClose: () => void;
  methodForm: UseFormReturn<BusinessUnitPayloadForm>;
  initialValue: BusinessUnitPayloadForm;
  actionRefreshList: () => void;
  update: UpdateBusinessUnitUsecase;
  t: (key: string) => string;
}

export const formatDataEdit = async ({
  data,
  detail,
  handleClose,
  methodForm,
  initialValue,
  actionRefreshList,
  update,
  t,
}: FormatDataEditOptions) => {
  const action = () => {
    handleClose();
    methodForm.reset({ ...initialValue });
    actionRefreshList();
  };

  const callApi = async (payload: BusinessUnitPayloadForm) => {
    try {
      await update.run(payload);
      notification.success({
        message: t('common.businessUnitUpdatedSuccess'),
        placement: 'bottomRight',
      });
      action();
    } catch (error) {
      notification.error({
        message: t('common.error'),
        description: getErrorMessage(error),
        placement: 'bottomRight',
      });
    }
  };

  const detailCategoryLength = detail.categoryIds?.length ?? 0;
  const dataCategoryLength = data.categoryIds?.length ?? 0;
  const childrenLength = data.childrenIds?.length ?? 0;

  if (dataCategoryLength !== detailCategoryLength && childrenLength > 0) {
    confirm({
      title: t('common.applyCategoryToChildren'),
      icon: <ExclamationCircleOutlined />,
      onOk: async () => {
        await callApi({ ...data, applyCategoryToChildren: true });
      },
      onCancel: async () => {
        await callApi({ ...data, applyCategoryToChildren: false });
      },
    });
  } else {
    await callApi(data);
  }
};
